const ProviderType = Object.freeze({
  PEXELS: 'pexels',
  ADOBE_FREE: 'adobe-free',
})

export default ProviderType
